import _isObject from 'lodash/isObject';

export function parseJsonCode(value, parsingError) {
  return parsingError ? value : JSON.stringify(value, null, 2);
}

export function parseCssCode(value) {
  return _isObject(value) ? '' : value;
}
